(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["coming-soon-bilingual"] && !Shopify.designMode) return;
  try {
    
(function () {
  const section = document.querySelector('.plennia-cs');
  if (!section) return;
  if (section.dataset.plenniaInit === '1') return;
  section.dataset.plenniaInit = '1';

  const copyEl = section.querySelector('[data-plennia-copy]');
  let copy = { es: {}, en: {} };
  try { copy = JSON.parse(copyEl.textContent); } catch (e) {}

  const defaultLocale = section.dataset.defaultLocale || 'es';
  let currentLang = (function () {
    try {
      const stored = window.localStorage.getItem('plennia_lang');
      if (stored === 'es' || stored === 'en') return stored;
    } catch (e) {}
    return defaultLocale;
  })();
  let currentCity = 'other';

  const flagBtn = section.querySelector('[data-lang-toggle]');
  const flagImg = section.querySelector('[data-flag-img]');
  const flagLabel = section.querySelector('[data-flag-label]');
  const tagsInput = section.querySelector('[data-customer-tags]');
  const FLAG_UK = flagImg ? flagImg.src.replace('spain-flag', 'uk-flag') : '';
  const FLAG_ES = flagImg ? flagImg.src.replace('uk-flag', 'spain-flag') : '';

  function applyLang() {
    try { window.localStorage.setItem('plennia_lang', currentLang); } catch (e) {}
    document.documentElement.lang = currentLang;
    const dict = copy[currentLang] || {};
    section.querySelectorAll('[data-i18n]').forEach(function (el) {
      const key = el.getAttribute('data-i18n');
      if (dict[key] !== undefined) el.textContent = dict[key];
    });
    section.querySelectorAll('[data-i18n-placeholder]').forEach(function (el) {
      const key = el.getAttribute('data-i18n-placeholder');
      if (dict[key] !== undefined) el.setAttribute('placeholder', dict[key]);
    });
    if (flagImg && flagLabel) {
      if (currentLang === 'es') {
        flagImg.src = FLAG_UK;
        flagLabel.textContent = 'EN';
        if (flagBtn) flagBtn.setAttribute('aria-label', 'Switch to English');
      } else {
        flagImg.src = FLAG_ES;
        flagLabel.textContent = 'ES';
        if (flagBtn) flagBtn.setAttribute('aria-label', 'Cambiar a espanol');
      }
    }
    updateTags();
  }

  function updateTags() {
    if (!tagsInput) return;
    tagsInput.value = 'coming-soon-signup,lang-' + currentLang + ',city-' + currentCity + ',signup-source-coming-soon-page';
  }

  if (flagBtn) {
    flagBtn.addEventListener('click', function () {
      currentLang = (currentLang === 'es') ? 'en' : 'es';
      applyLang();
    });
  }

  function selectVideo(city) {
    const isMobile = window.innerWidth < 750;
    const device = isMobile ? 'mobile' : 'desktop';
    const videos = section.querySelectorAll('.plennia-cs__video');
    videos.forEach(function (v) {
      if (v.dataset.city === city && v.dataset.device === device) {
        v.classList.add('is-active');
        v.load();
        const playPromise = v.play();
        if (playPromise) playPromise.catch(function () {});
      } else {
        v.classList.remove('is-active');
      }
    });
  }

  function setCity(city) {
    currentCity = (city === 'madrid' || city === 'barcelona') ? city : 'other';
    const videoCity = (city === 'madrid' || city === 'barcelona') ? city : (Math.random() < 0.5 ? 'madrid' : 'barcelona');
    selectVideo(videoCity);
    updateTags();
  }

  function getCityOverride() {
    try {
      const params = new URLSearchParams(window.location.search);
      const c = (params.get('city') || '').toLowerCase();
      if (c === 'madrid' || c === 'barcelona') return c;
    } catch (e) {}
    return null;
  }

  /*
   * IP geolocation (ipapi.co) transmits the visitor's IP address to a third
   * party. Under GDPR + LSSI-CE Art. 22.2 that requires prior consent, so it
   * runs only once Shopify's Customer Privacy API reports analytics consent.
   * Without consent the page falls back to a random Madrid/Barcelona video --
   * no functional loss. Do not call ipapi.co outside runGeo().
   */
  function analyticsConsentGranted() {
    try {
      const api = window.Shopify && window.Shopify.customerPrivacy;
      if (!api || typeof api.analyticsProcessingAllowed !== 'function') return false;
      return api.analyticsProcessingAllowed() === true;
    } catch (e) { return false; }
  }

  let geoRan = false;
  function runGeo() {
    if (geoRan) return;
    geoRan = true;
    fetch('https://ipapi.co/json/')
      .then(function (r) { return r.json(); })
      .then(function (data) {
        const cityRaw = (data && data.city) ? String(data.city).toLowerCase() : '';
        let detected = 'other';
        if (cityRaw.indexOf('madrid') !== -1) detected = 'madrid';
        else if (cityRaw.indexOf('barcelona') !== -1 || cityRaw.indexOf('barcelone') !== -1) detected = 'barcelona';
        setCity(detected);
      })
      .catch(function () { setCity('other'); });
  }

  function runGeoIfConsented() {
    if (analyticsConsentGranted()) runGeo();
  }

  const override = getCityOverride();
  if (override) {
    setCity(override);
  } else {
    setCity('other');
    document.addEventListener('visitorConsentCollected', runGeoIfConsented);
    if (window.Shopify && typeof window.Shopify.loadFeatures === 'function') {
      window.Shopify.loadFeatures(
        [{ name: 'consent-tracking-api', version: '0.1' }],
        function (error) { if (!error) runGeoIfConsented(); }
      );
    }
  }

  let resizeTimer;
  window.addEventListener('resize', function () {
    clearTimeout(resizeTimer);
    resizeTimer = setTimeout(function () {
      const isMobile = window.innerWidth < 750;
      const device = isMobile ? 'mobile' : 'desktop';
      const activeVideo = section.querySelector('.plennia-cs__video.is-active');
      if (activeVideo && activeVideo.dataset.device !== device) {
        const cityClass = activeVideo.dataset.city;
        selectVideo(cityClass);
      }
    }, 200);
  });

  applyLang();
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
